import { UTILITY_BILL_PAGE } from "../../route-consts";

export const UTILITY_BILL_ALL_DATAENTRIES_VIEW = {
  PATH: "Data_Entries",
  ABSOLUTE_PATH: (billId: string) =>
    `${UTILITY_BILL_PAGE.ABSOLUTE_PATH(billId)}/Data_Entries`,
  TITLE: "ALL DATA ENTRIES",
};
